import moment, { Moment } from "moment";
import "moment-timezone";
export const DateToUnixConverter = (date: Moment): number => {
  //converts to UTC
  return moment.utc(date).unix();
};

export const UnixToDateConverter = (date: number): Moment => {
  //converts to locale
  return moment.unix(date);
};

export const setGlobalTimezone = (timezone: string) => {
  moment.tz.setDefault(timezone);
};
